import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import apiClient from "../apiClient";
import {
  IJournalsParams,
  IJournalsResponse,
  JournalBody,
} from "src/types/events/manual-journals";

export const useGetManualJournalsList = (params: IJournalsParams) =>
  useQuery<any, APIErrorResponse, IJournalsResponse>({
    queryKey: [
      "get-manual-journals-list",
      params.page,
      params.start_date,
      params.end_date,
      params.status,
      params.branch_id,
      params.description,
      params.reference_number,
    ],
    queryFn: async () => {
      return apiClient.get(`/api/journals`, { params });
    },
  });

export const useAddManualJournalMutation = () =>
  useMutation<void, APIErrorResponse, FormData>({
    mutationFn: async (data) => {
      return apiClient.post(`/api/journals`, data);
    },
  });

export const useUpdateManualJournalMutation = () =>
  useMutation<void, APIErrorResponse, JournalBody>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiClient.put(`/api/journals/${id}`, rest);
    },
  });

export const useDeleteManualJournalMutation = () =>
  useMutation<void, APIErrorResponse, number>({
    mutationFn: async (id) => {
      return apiClient.delete(`/api/journals/${id}`);
    },
  });

export const useDownloadManualJournals = (params: IJournalsParams) =>
  useQuery<any, APIErrorResponse, any>({
    queryKey: ["download-manual-journals-list"],
    queryFn: async () => {
      return apiClient.get(`/api/journals/download`, { params });
    },
    enabled: false,
    gcTime: 0,
  });
